var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"btn btn-primary mr-2",class:[_vm.btnClass, {'spinner spinner-white spinner-right': _vm.loading}],attrs:{"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }